import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { FolderOpen, Upload, BarChart3, Bot } from 'lucide-react';

const UserDashboard = () => {
  const navigate = useNavigate();

  const features = [
    { icon: FolderOpen, title: 'Projects', desc: 'Access your construction projects', path: '/app/projects', color: 'blue' },
    { icon: Upload, title: 'Uploads', desc: 'Upload and manage files', path: '/app/projects', color: 'green' },
    { icon: BarChart3, title: 'Analytics', desc: 'Coming soon', path: '#', color: 'purple' },
    { icon: Bot, title: 'AI Assistant', desc: 'Get intelligent insights', path: '/app/assistant', color: 'orange' },
  ];

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white">Dashboard</h1>
          <p className="text-slate-600 dark:text-slate-400 mt-1">Welcome to ReasonVisionX</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, idx) => {
            const Icon = feature.icon;
            return (
              <div key={idx} onClick={() => feature.path !== '#' && navigate(feature.path)} className={`bg-white dark:bg-slate-900 rounded-xl p-6 border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-md transition-all ${feature.path !== '#' ? 'cursor-pointer' : 'opacity-60'}`} data-testid={`feature-${feature.title.toLowerCase()}`}>
                <div className={`w-12 h-12 bg-${feature.color}-100 dark:bg-${feature.color}-950/50 rounded-lg flex items-center justify-center mb-4`}>
                  <Icon className={`w-6 h-6 text-${feature.color}-600 dark:text-${feature.color}-400`} />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-1">{feature.title}</h3>
                <p className="text-sm text-slate-600 dark:text-slate-400">{feature.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-slate-900 dark:to-slate-800 rounded-xl p-8 border border-blue-200 dark:border-slate-700">
          <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-2">Get Started</h2>
          <p className="text-slate-700 dark:text-slate-300 mb-4">Upload construction scans, analyze objects, take measurements, and visualize in 3D.</p>
          <button onClick={() => navigate('/app/projects')} className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors shadow-md">View Projects</button>
        </div>
      </div>
    </Layout>
  );
};

export default UserDashboard;
